import { type ExternalUserServiceIntegration } from '../../../../../models/User'
import { useState } from 'react'
import { DelegatedEmailVerificationStatus } from './DelegatedEmailVerificationStatus'
import { useAppDispatch, useAppSelector } from '../../../../../store/hooks'
import { selectAccountId, selectSafeAuthenticatedUser } from '../../../../../store/auth/authSlice'
import { addToast } from '../../../../../store/toast/toastSlice'
import { useClaimExternalUserMutation } from '../../../../../store/user/user'
import { Button } from '../../../../../components/Button/Button'
import { IntegrationServiceId } from '../../../../../common/integrations'
import { DeleteDelegatedEmailModal } from '../../../Connectors/ModalIntegrationConnectors/DelegatedEmail/DeleteDelegatedEmailModal'
import { TrackEvent, useTracking } from '../../../../../apps/professional-app/fa/common/tracking'

export interface DelegatedEmailListItemProps {
  integration: ExternalUserServiceIntegration
}

export const DelegatedEmailListItem = ({ integration }: DelegatedEmailListItemProps) => {
  const dispatch = useAppDispatch()
  const accountId = useAppSelector(selectAccountId)
  const { id: currentUserId } = useAppSelector(selectSafeAuthenticatedUser)
  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const [claimExternalUser, { isLoading: isSending }] = useClaimExternalUserMutation()
  const { tracked } = useTracking()

  const _handleSendCode = async () => {
    const result = await claimExternalUser({
      accountId,
      integrationName: IntegrationServiceId.DELEGATED_EMAIL,
      payload: { delegatedEmail: integration.externalId, integrationId: integration.id },
    })
    if (!('error' in result)) {
      dispatch(addToast({ variant: 'success', title: 'Success', messages: ['Verification code sent'] }))
    }
  }

  const handleSendCode = tracked(_handleSendCode, {
    eventName: TrackEvent.DELEGATED_EMAIL_SEND_CODE,
    eventDetails: {
      userId: currentUserId,
    },
  })

  return (
    <>
      {showDeleteModal ? (
        <DeleteDelegatedEmailModal accountId={accountId} userId={currentUserId} integration={integration} onHide={() => setShowDeleteModal(false)} />
      ) : null}
      <div className='d-flex p-2 border rounded zocks-border-color-gray-200'>
        <div className='d-flex flex-column flex-grow-1'>
          <span className='bold'>{integration.externalId}</span>
          <DelegatedEmailVerificationStatus state={integration.state} />
        </div>
        <div className='d-flex justify-content-end align-items-center'>
          {integration.state === 'invalid' || integration.state === 'validating' ? (
            <Button variant='grayButton' onClick={handleSendCode} loading={isSending}>
              <span className='button-medium'>Send code</span>
            </Button>
          ) : null}
          <Button className='p-2 ms-2' variant='grayButton' onClick={() => setShowDeleteModal(true)}>
            <i className='bi bi-trash' />
          </Button>
        </div>
      </div>
    </>
  )
}
